import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../redux/actions/modals";
import Button from "../button";
import ModalTemplate from "./template";

const GalleryImageModal = () => {
  const dispatch = useDispatch();
  const hide = () => {
    dispatch(hideModal());
  };

  return (
    <ModalTemplate title="راهنمای انتخاب تصویر مطب" icon="far fa-star">
      <div className="p-5 leading-8 text-normal">
        در این قسمت شما می‌توانید حداکثر ۸ تصویر افقی برای نمایش در بخش گالری صفحه خود انتخاب کنید.
        <ul className="list-disc">
          <li>عکس‌ها به صورت افقی باشند.</li>
          <li>
            عکس‌های مجاز برای استفاده در این بخش می‌تواند از فضای مطب، میز کار، راهرو، سالن انتظار و سردر مطب باشد.
          </li>
        </ul>
        دقت داشته باشید که تصاویر حذف شده، پس از تایید شما مستقیما از صفحه پاک می‌شوند اما موارد اضافه شده توسط تیم
        پشتیبانی پزشک خوب بررسی شده و در صورتی که مطابق شرایط ذکر شده باشند، تایید خواهند شد.
      </div>
      <div>
        <Button className="w-full" onClick={hide}>
          بستن توضیحات
        </Button>
      </div>
    </ModalTemplate>
  );
};

export default GalleryImageModal;
